import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link } from "react-router-dom";
import { flutter, react } from "../data/frameworks";
import { ProjectModel } from "../models/projectModel";
import { ScaledImage } from "./scaledImage";

interface Props {
  project: ProjectModel;
}

export const ProjectWidgetPortrait = ({ project }: Props) => {
  const [showDesc, setShowDesc] = useState(false);
  const frameworkIconPath =
    project.framework.name === flutter.name ||
    project.framework.name === react.name
      ? `/assets/icons/${project.framework.svg}`
      : `/assets/icons/${project.framework.icon}`;
  return (
    <Link to={`./${project.key}`}>
      <div
        className="bg-gray-200 rounded-xl relative cursor-pointer overflow-hidden  shadow-xl h-full "
        onMouseEnter={() => setShowDesc(true)}
        onMouseLeave={() => setShowDesc(false)}
      >
       <div className="hover:opacity-80 ">
         <ScaledImage
          category={project.category}
          imagePath={project.coverImage}
          alt={project.key}
          index={0}
          isCover={true}
        />
         
         </div> 
         

        <div className="absolute bottom-0 right-0 w-full  bg-gray-300 ">
          <div className="inline-flex flex-row w-full justify-between items-center flex-wrap">
            <span className="text-lg lg:text-xl font-medium px-2 py-5">
              {project.title}
            </span>
            <div
              className={`${
                project.framework.name === react.name
                  ? "bg-primary rounded-md"
                  : ""
              } p-1  `}
            >
              <img
                src={frameworkIconPath}
                className="h-6"
                alt={project.framework.name}
              />
            </div>
          </div>
        </div>

        {/* <div className="absolute right-0 top-0 w-full h-full transform -translate-y-3/4 translate-x-1/3 -rotate-45  bg-cardHoverColor"></div> */}

        {showDesc && (
          <div className="absolute bottom-0 w-full bg-gray-300 p-2 ">
            <div className="inline-flex flex-col w-full">
              <div className="inline-flex flex-row justify-between items-center w-full flex-wrap">
                <span className="text-lg lg:text-xl font-medium">{project.title}</span>
                <div
                  className={`${
                    project.framework.name === react.name
                      ? "bg-primary rounded-md"
                      : ""
                  } p-1  `}
                >
                  <img
                    src={frameworkIconPath}
                    className="h-6" 
                    alt={project.framework.name}
                  />
                </div>
              </div>
              <div className="inline-flex flex-row items-end justify-between text-justify w-full">
                <p className=" ">{`${project.description.substring(
                  0,
                  100
                )}...`}</p>
                <span>
                  <FontAwesomeIcon icon={faAngleDoubleRight} />
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </Link>
  );
};
